@if (label()) {
  <label for="inputText" class="col-span-12 mb-1 text-sm font-medium">
    {{ label() }}
    @if (required()) {
      <span class="text-indicator-error">*</span>
    }
  </label>
}

<textarea
  pSize="small"
  pTextarea
  id="inputTextarea"
  [disabled]="isDisabled()"
  [placeholder]="placeholder()"
  [value]="value"
  (input)="onInput($event)"
  (blur)="onBlur()"
  class="col-span-12"
  [ngClass]="{ 'ng-invalid': showErrors, 'ng-dirty': showErrors }"
  (click)="$event.stopPropagation()"
  [autoResize]="autoResize()"
  [rows]="rows()"
  [cols]="cols()"
  [fluid]="true"
></textarea>

<app-helper-text
  class="col-span-12"
  [errorMessage]="errorMessage"
  [showErrors]="showErrors"
  [helperText]="helperText()"
/>
